import React from "react";
import {BsExclamationLg} from "react-icons/bs";

interface Props {
  openCrowdedStepGuideModal: () => void;
}
interface State {}

export default class CrowdedLinearGraph extends React.Component<Props, State> {

  renderGraphLabel = (label: string) => {
    return (
      <div style={{color: "#A1A4AC", fontSize: 12, textAlign: "center"}}>
        <div style={{height: 6, width: "50%", borderRight: "1px solid #A1A4AC"}}></div>
        <div style={{height: 4}}/>
        <div>{label}</div>
      </div>
    )
  }

  render() {
    return (
      <div>
        <div className={"txt"} style={{display: "flex", alignItems: "center"}}>
            <span
              onClick={this.props.openCrowdedStepGuideModal}
              style={{backgroundColor: "#FFFFFF40", borderRadius: 100, width: 20, height: 20, display: "flex", justifyContent: "center", alignItems: "center", marginRight: 10, cursor: "pointer"}}>
              <BsExclamationLg size={10}/>
            </span>
          <span>인구 혼잡도 단계 안내</span>
        </div>

        <div
          style={{
            backgroundImage: "linear-gradient(to right, #4DA1FF, #4DFFDF, #C6FF4D, #FFAD4D, #FF584D, #EE3535)",
            height: 15,
            marginLeft: 20,
            marginRight: 10,
            marginTop: 15,
            borderRadius: 10,
            position: "relative"
          }}
        >
          <div style={{backgroundColor: "#FFFFFF", width: 21, height: 21, borderRadius: 100, position: "absolute", left: "80%", top: "50%", transform: "translate(-80%, -50%)"}}/>
        </div>

        <div style={{display: "flex", position: "relative", flexDirection: "row", marginLeft: 20, marginRight: 10, padding: "0 17px", justifyContent: "space-between"}}>
          {this.renderGraphLabel("여유")}
          {this.renderGraphLabel("보통")}
          {this.renderGraphLabel("주의")}
          {this.renderGraphLabel("경계")}
          {this.renderGraphLabel("심각")}
        </div>
      </div>
    );
  }
}
